import { Dialog } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useKillSwitchGateOpen, useKillSwitchGateKind, useCloseKillSwitchGate } from '@/store/killSwitchGateStore';

/**
 * Kill-switch gate screen. Mount once in the app shell. Opened by the 503
 * interceptor as the reactive backstop to the client-side LD UX (disabled CTAs).
 * Dismissable — the block is server-enforced, so dismissing just lets the user
 * keep browsing.
 */
export function KillSwitchGate() {
  const open = useKillSwitchGateOpen();
  const kind = useKillSwitchGateKind();
  const close = useCloseKillSwitchGate();

  if (!open) return null;

  const { title, body } =
    kind === 'MAINTENANCE'
      ? {
          title: 'Down for maintenance',
          body: "We're making some improvements and will be back shortly. Thanks for your patience.",
        }
      : {
          title: 'Temporarily unavailable',
          body: 'This action is paused right now. Please try again in a little while.',
        };

  return (
    <Dialog open onClose={close} size="md">
      <div className="flex flex-col gap-4 text-center">
        <h2 className="text-lg font-semibold text-primary">{title}</h2>
        <p className="text-sm text-muted">{body}</p>
        <Button onClick={close} className="w-full">
          Got it
        </Button>
      </div>
    </Dialog>
  );
}
